import "../../common/js/polyfills"
import Alpine from "alpinejs"
import fraudNetIntegration from "./fraudNetIntegration"
import commonTrackingPageInit from "./services/tracking/trackingPageInit"
import translation from "../../common/js/translation"
import { getOrderData } from "./getOrderData"
import { errorsManager } from "./services/errors/errorsManager"
import { bugsnagAdapter } from "./services/errors/bugsnagAdapter"
import { sentryAdapter } from "./services/errors/sentryAdapter"

function handleImageLoad(img) {
  if (img.complete) {
    // Image was already loaded from cache
    window.requestAnimationFrame(() => {
      img.classList.add("pipe-img-loaded")
    })
  } else {
    // Wait for image to load
    img.onload = () => img.classList.add("pipe-img-loaded")
  }
}

function watchForNewImages() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.tagName === "IMG") {
          handleImageLoad(node)
        } else if (node.querySelectorAll) {
          // Potentially the whole chunk of HTML can be added,
          // which may contain multiple imgs inside
          node.querySelectorAll("img").forEach(handleImageLoad)
        }
      })
    })
  })

  observer.observe(document.body, { childList: true, subtree: true })
}

function handleDOMContentLoaded() {
  const body = document.querySelector("body")

  // Add a CSS class to trigger animation
  window.requestAnimationFrame(() => {
    body.classList.add("pipe-dom-content-loaded")
  })

  const svgs = document.querySelectorAll("svg[data-pipe-svg-animation]")
  svgs.forEach((svg) => {
    window.requestAnimationFrame(() => {
      svg.classList.add("pipe-svg-loaded")
    })
  })

  const imgs = document.querySelectorAll("img")
  imgs.forEach(handleImageLoad)
  watchForNewImages()
}

export default ({ components, dataStore, trackingPageInit, DOMContentLoadedCallback }) => {
  errorsManager.init({
    adapters: [bugsnagAdapter, sentryAdapter],
  })

  // DOMContentLoaded
  document.addEventListener("DOMContentLoaded", () => {
    handleDOMContentLoaded()

    if (DOMContentLoadedCallback) DOMContentLoadedCallback()
  })

  // Init Alpine
  window.Alpine = Alpine
  // Add global Alpine error handler, which will catch all errors from Alpine expressions and directives
  Alpine.setErrorHandler((error, el, expression) => {
    const directives = el
      ? Array.from(el.attributes)
          .filter((attr) => attr.name.startsWith("x-"))
          .map((attr) => `${attr.name}="${attr.value}"`)
      : []

    console.error("Alpine error:", { message: error.message, expression, directives })

    errorsManager.reportAlpineError(error, {
      expression,
      directives,
      template: el?.outerHTML?.substring(0, 300),
      parentId: el?.closest("[id]")?.id,
    })
  })

  components.forEach(({ name, data }) => {
    Alpine.data(name, data)
  })

  getOrderData(dataStore).then(async () => {
    Alpine.store("data", dataStore)
    Alpine.start()
    translation.onInit()
  })

  // Init internal analytics tracking
  trackingPageInit = trackingPageInit || commonTrackingPageInit
  trackingPageInit()

  // Init FraudNet
  fraudNetIntegration()
}
